"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "nervesa-della-battaglia": {
    "sovilla": [{
      "hkey": "3887d4a6",
      "slug": "centro-sovilla",
      "name": "Centro-Sovilla",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7c0e2b8a": [{
      "hkey": "3887d4a6",
      "slug": "centro-sovilla",
      "name": "Centro-Sovilla",
      "primary": true,
      "skipSearch": false
    }],
    "sant-andrea": [{
      "hkey": "3887d4a6",
      "slug": "centro-sovilla",
      "name": "Centro-Sovilla",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7fb3e42a": [{
      "hkey": "3887d4a6",
      "slug": "centro-sovilla",
      "name": "Centro-Sovilla",
      "primary": true,
      "skipSearch": false
    }],
    "08904989": [{
      "hkey": "2ec8c18b",
      "slug": "nervesa-della-battaglia",
      "name": "Nervesa della Battaglia",
      "primary": true,
      "skipSearch": false
    }],
    "ss-angeli": [{
      "hkey": "2ec8c18b",
      "slug": "nervesa-della-battaglia",
      "name": "Nervesa della Battaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "66df9062": [{
      "hkey": "3887d4a6",
      "slug": "centro-sovilla",
      "name": "Centro-Sovilla",
      "primary": true,
      "skipSearch": false
    }],
    "centro-sant-andrea-sovilla": [{
      "hkey": "3887d4a6",
      "slug": "centro-sovilla",
      "name": "Centro-Sovilla",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;